// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { tellAFriend } from "@awc/App/Services/TellAFriend";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter, SendDataToApi } from "@insite/client-framework/Store/CommonHandlers/ShareProduct";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    (props.apiParameter as any).reCaptchaResponse = (props.parameter as any).reCaptchaResponse;
};
export const XngSendDataToApi: typeof SendDataToApi = async props => {
    const result = (await tellAFriend(props.apiParameter as any)) as any;
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        (props.parameter as any).onError?.(result.errorMessage);
        return false;
    }
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, SendDataToApi, XngSendDataToApi);
